var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watch-options-delete"},[_c('p',[_vm._v("Remove patient?")]),_vm._v(" "),_c('button-icon-text-loading',{attrs:{"icon":"check"},nativeOn:{"click":function($event){return _vm.deletePatient($event)}}},[_vm._v(_vm._s(_vm.$t('buttons.general.delete')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2f62830","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watch/options/WatchOptionsDelete.vue
// module id = null
// module chunks = 